import React from 'react';
import { jsx } from '@emotion/react';

const VisibleOnRowHover: React.FC = ({children})=> <div className={"visible-on-row-hover"}>{children}</div>

export default React.memo(VisibleOnRowHover) as typeof VisibleOnRowHover;
